import { TableSimples } from "../../../../../components/BasicComponents/DisplayDados/TableSimples";
import { PaperBox } from "../../../../../components/Layout/PaperBox";
import { IDataDashboardReceituario } from "../../../../../types/api/receituarioAgronomico/dashboard-receituario";


export default function CardListagemTecnicos({
    dataDashboard
}: CardListagemTecnicosProps) {

    return (
        <PaperBox style={{ height: '100%' }} p={2}>
            <TableSimples
                headers={[
                    { label: "Técnico agrícola" },
                    { label: "Loja" },
                    { label: "Receitas emitidas", numeric: true },
                    { label: "Receitas restantes", numeric: true },
                ]}
                rows={dataDashboard.tecnicos_receitas.map(row => ({
                    columns: [
                        { value: `${row.agronomo_nome}` },
                        { value: `${row.loja_nome}` },
                        { value: row.total_receitas_emitidas, numeric: true },
                        { value: row.total_receitas_restantes, numeric: true },
                    ]
                }))}
                total={{
                    label: "Total receitas emitidas",
                    value: (dataDashboard.tecnicos_receitas.reduce((total, row) => total + row.total_receitas_emitidas, 0))
                }}
            />
        </PaperBox>
    )
}

interface CardListagemTecnicosProps {
    dataDashboard: IDataDashboardReceituario;
}
